import { createSelector } from 'reselect'

const referralSource = (state) => state?.admin?.referralSource || {}

export const referralSourceItem$ = createSelector(
  referralSource,
  ({ referralSourceItem = [] }) => referralSourceItem
)

export const referralSourceList$ = createSelector(
  referralSource,
  ({ referralSourceList = [] }) => referralSourceList
)
